module.exports = __webpack_public_path__ + "assets/f96edca1ecca6b29032000f497f83e7a.png";